import { api_request } from '../axios_client';
import { handleError } from '../common';
import * as Constants from '../constants';

const isSI = true;
const v1SiCleartaxIrnGeneratePost = async (soId, box_quantities_or_bag_qty, str_number, options) => {
  const resourcePath = `${Constants.PATH.SALES.CLEAR_TAX.generateIRN}`;
  try {
    const isBoxQuantitiesArray = Array.isArray(box_quantities_or_bag_qty);
    const params = { soId, str_number };
    const data = {};
    
    if (isBoxQuantitiesArray) {
      data.box_quantities = box_quantities_or_bag_qty;
    } else {
      params.bag_qty = box_quantities_or_bag_qty;
    }
    
    const res = await api_request({
      methodType: 'post',
      resourcePath,
      params,
      data: isBoxQuantitiesArray ? data : undefined,
      options,
      isSI
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiCleartaxEwaybillGeneratePost = async (data, options) => {
  const resourcePath = `${Constants.PATH.SALES.CLEAR_TAX.generateEwaybill}`;
  try {
    const res = await api_request({
      methodType: 'post',
      resourcePath,
      data,
      options,
      isSI
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiCleartaxDeliveryChallanGeneratePost = async (soId, box_quantities_or_bag_qty, str_number, options) => {
  const resourcePath = `${Constants.PATH.SALES.CLEAR_TAX.generateDeliveryChallan}`;
  try {
    const isBoxQuantitiesArray = Array.isArray(box_quantities_or_bag_qty);
    const params = { soId, str_number };
    const data = {};
    
    if (isBoxQuantitiesArray) {
      data.box_quantities = box_quantities_or_bag_qty;
    } else {
      params.bag_qty = box_quantities_or_bag_qty;
    }
    
    const res = await api_request({
      methodType: 'post',
      resourcePath,
      params,
      data: isBoxQuantitiesArray ? data : undefined,
      options,
      isSI
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

export { v1SiCleartaxIrnGeneratePost, v1SiCleartaxEwaybillGeneratePost, v1SiCleartaxDeliveryChallanGeneratePost };
